import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import "mdbvue/build/css/mdb.css";
import axios from "axios";
import {store} from './store'
import {API_KEY_CLIENT, API_SECRET_KEY, BACKEND_YSY, CALLBACK_UI_COGNITO} from "./env";
import ToggleSwitch from 'vuejs-toggle-switch'
import ProgressBar from 'vuejs-progress-bar'
import VueAnalytics from 'vue-analytics';
import {constants} from './constants';

Vue.use(VueAnalytics, {
  id: 'UA-179140074-1',
  router
});

//BootstrapVue
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)

//VueApexCharts
import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts)

//vue-icon
import feather from 'vue-icon'

Vue.use(feather, 'v-icon')

//bus-event
export const eventBus = new Vue();

Vue.use(ProgressBar);
Vue.use(ToggleSwitch);

//vue-side-bar
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import VueSidebarMenu from 'vue-sidebar-menu'

Vue.use(VueSidebarMenu);

//aeroland
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueSilentbox from 'vue-silentbox'
import WOW from 'wow.js/dist/wow.js';

Vue.use(VueSilentbox);
Vue.use(VueAwesomeSwiper);

import '../src/assets/css/fontawesome-all.min.css'
import 'swiper/dist/css/swiper.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'slick-carousel/slick/slick.css'
///

///argon framework
import DashboardPlugin from './plugins/dashboard-plugin';

Vue.use(DashboardPlugin);

///overlayPlugin
// eslint-disable-next-line no-duplicate-imports
import {OverlayPlugin} from 'bootstrap-vue'

Vue.use(OverlayPlugin)

//vueCookies
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.$cookies.set('theme', 'ysy-default');

//Load scripts
import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);

Vue.config.productionTip = false;
Vue.config.productionSourceMap = false;
Vue.prototype.$http = axios;
Vue.prototype.$cookie = VueCookies;
Vue.prototype.API_KEY_CLIENT_VUE = API_KEY_CLIENT;
Vue.prototype.API_SECRET_KEY_VUE = API_SECRET_KEY;
Vue.prototype.BACKEND_YSY = BACKEND_YSY;
Vue.prototype.CALLBACK_UI_COGNITO = CALLBACK_UI_COGNITO;
Vue.prototype.$constants = constants;

new Vue({
  router,
  store,
  mounted() {
    new WOW().init();
  },
  render: h => h(App)
}).$mount("#app");
